import { render, staticRenderFns } from "./Knob.vue?vue&type=template&id=5b58c0ec&scoped=true&"
import script from "./Knob.vue?vue&type=script&lang=js&"
export * from "./Knob.vue?vue&type=script&lang=js&"
import style0 from "./Knob.vue?vue&type=style&index=0&id=5b58c0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58c0ec",
  null
  
)

export default component.exports